import {
  DataPointValue,
  DateRangeFilter,
  ICustomReportFilter,
  ReportFilterComparison,
} from '@principle-theorem/principle-core/interfaces';
import {
  FilterAccessor,
  IAccessorContext,
} from '@principle-theorem/reporting/interfaces';
import {
  ISODateType,
  Timezone,
  isArray,
  toMoment,
} from '@principle-theorem/shared';
import { BigQuerySQL } from '../../big-query-sql';
import { getBigQueryComparison } from '../../querying';
import { CustomReportFilter } from '../custom-report-filters';

export class BirthdayFilterAccessor {
  static filterAccessor(path: string): FilterAccessor {
    return (filter: ICustomReportFilter, context: IAccessorContext) => {
      const comparison = CustomReportFilter.getComparison(filter);

      const sqlFilters = filter.values.map((filterValue) => {
        // Special handling for ReportFilterComparison.DateIsBetween
        if (isArray(filterValue.value)) {
          return BirthdayFilterAccessor.dateRangeFilter(
            path,
            context.timezone,
            filter,
            filterValue.value
          );
        }
        return BirthdayFilterAccessor.dateFilter(
          path,
          context.timezone,
          filter,
          filterValue.value
        );
      });

      return comparison === ReportFilterComparison.IsNotEqualTo
        ? BigQuerySQL.and(sqlFilters)
        : BigQuerySQL.or(sqlFilters);
    };
  }

  static dateRangeFilter(
    path: string,
    timezone: Timezone,
    _filter: ICustomReportFilter,
    filterValue: DateRangeFilter
  ): string {
    const [from, to] = filterValue;
    const valueDate = BirthdayFilterAccessor.getDateValue(
      `TIMESTAMP(${path})`,
      timezone
    );
    const fromDate = BirthdayFilterAccessor.getDateValue(`'${from}'`, timezone);
    const toDate = BirthdayFilterAccessor.getDateValue(`'${to}'`, timezone);

    const minimum = `${valueDate} >= ${fromDate}`;
    const maximum = `${valueDate} <= ${toDate}`;

    const fromMonth = BirthdayFilterAccessor.getMonthFromDate(from);
    const toMonth = BirthdayFilterAccessor.getMonthFromDate(to);

    return fromMonth > toMonth
      ? BigQuerySQL.or([minimum, maximum])
      : BigQuerySQL.and([minimum, maximum]);
  }

  static dateFilter(
    path: string,
    timezone: Timezone,
    filter: ICustomReportFilter,
    filterValue: DataPointValue | ISODateType
  ): string {
    const comparison = CustomReportFilter.getComparison(filter);
    const valueDate = BirthdayFilterAccessor.getDateValue(
      `TIMESTAMP(${path})`,
      timezone
    );
    const filterDate = BirthdayFilterAccessor.getDateValue(
      `'${filterValue}'`,
      timezone
    );
    const bigQueryComparison = getBigQueryComparison(filter, comparison);
    return `${valueDate} ${bigQueryComparison} ${filterDate}`;
  }

  static getDateValue(dateValue: string, timezone: Timezone): string {
    const month = `EXTRACT(MONTH FROM DATE(${dateValue}, "${timezone}"))`;
    const day = `EXTRACT(DAY FROM DATE(${dateValue}, "${timezone}"))`;
    return `CAST(FORMAT('%02d%02d', ${month}, ${day}) AS INT64)`;
  }

  static getMonthFromDate(date: string): string {
    return toMoment(date).format('MM');
  }
}
